// extracted by mini-css-extract-plugin
export default {"melodyVideo":"MR-z","isFullWidth":"NR-z","landingPageVideo":"OR-z","play":"PR-z","iframeVideo":"QR-z","playHidden":"RR-z","fullwidth":"SR-z"};